module.exports = __webpack_public_path__ + "img/yellow.cc2ca302.svg";